// extracted by mini-css-extract-plugin
export default {"date-range":"DateRange--date-range--DpK2L","dateRange":"DateRange--date-range--DpK2L"};